import './config';
import { apiBaseUrl } from './config';
import { getBaseHeader } from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_YEARS = 'ppis/years';

export default class PPIYearService extends SfpBaseService {

    static updatePPIYear(year_id, property, value) {
        var values = {}
        values[property] = value
        const body = JSON.stringify({ ppi_year: values });
        const headers = {
            ...getBaseHeader(),
            'Content-Type': 'application/json'
        };

        return fetch(`${apiBaseUrl}/ppis/${year_id}/year`, { body, headers, method: "PUT" })
            .then(super.returnResponse);
    }

    static updatePPIYearInvestResult(local_autority_id, year, invest_result) {
        const headers = {
            ...getBaseHeader(),
            'Content-Type': 'application/json'
        };
        return fetch(`${apiBaseUrl}/ppisyears/localAutority/${local_autority_id}/year/${year}/investResult/${invest_result}`, { headers, method: "PUT" })
            .then(super.returnResponse);
    }
}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-year-service.js